module.exports = __webpack_public_path__ + "img/2021_actMap.d55c9e83.jpg";